import axios from "axios";
import end from './endpoint';
import auth from "./auth";
const ENDPOINT = end.PATH + "evidences-comments/";

export default {
    get() {
        const token = auth.getSession();
        return axios.get(ENDPOINT, { headers: { token } });
    },

    getOne(id) {
        const token = auth.getSession();
        return axios.get(ENDPOINT + id, { headers: { token } });
    },

    insert(comment) {
        const token = auth.getSession();
        return axios.post(ENDPOINT, comment, { headers: { token } });
    },

    update(id, comment) {
        const token = auth.getSession();
        return axios.put(ENDPOINT + id, comment, { headers: { token } });
    },

    delete(id) {
        const token = auth.getSession();
        return axios.delete(ENDPOINT + id, { headers: { token } });
    },
};